import { Component, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { NotificationService } from '../../service/notification.service';
import { NotificationType } from '../../enum/notification-type.enum';
import { CalendarService } from '../../service/calendar.service';
import { CalendarModel } from '../../models/config/calendar.model';
import { Router } from '@angular/router';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { NgForm } from '@angular/forms';
import { ErrorResponseMessage } from 'src/app/error-handler/error-response-message.model';
import { GlobalService } from 'src/app/service/global.service';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.css']
})
export class CalendarComponent implements OnInit {

  constructor(private globalService: GlobalService,private httpService: HttpClient, private router: Router, private calendarService: CalendarService,
    public ete: ExportExcelService, private authGaurdService: AuthGaurdService, private notificationService: NotificationService) { }

  ordersTableColumns: TableColumn[];
  fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  fileExtension = '.xlsx';
  fileName: string = 'CalendarData';
  columnsData: any;
  checked: boolean = false;
  actionButtons: any;
  actions: any;

  selctedValues: CalendarModel[] = [];
  isChecked: boolean = false;

  public calcData: CalendarModel[] = [];
  public filterData: CalendarModel[] = [];

  public calendarModel = new CalendarModel(0, '', null, null, null, null, '', '', '', '', null, '', null, '', false, null, '', '','');

  public loggedinUser: string = '';
  public errorMessage: string = '';
  public sucessMessage: string = '';
  private subscriptions: Subscription[] = [];
  public refreshing: boolean;
  public checkedactive: boolean = false;
  public isTableExpanded = false;
  public showLoading: boolean;
  public fname: string;

  selctedCals: CalendarModel[] = [];
  calData: CalendarModel[] = [];
  excelCalData: CalendarModel[] = [];


  columnsExcelData: any;
  dataForExcel = [];
  ordersTableExcelHeaderColumns: TableColumn[];

  isAccessDisabled: boolean = false;

  ngOnInit() {
    //Get Permissions
    this.isAccessDisabled = this.globalService._permissionCheck('calendar');

    this.loggedinUser = this.authGaurdService.loginUser();

    this.initializeColumns();
    this.getCalList();
    this.initializeExcelHeaders();
  }

  initializeExcelHeaders(): void {
    this.httpService.get('../../../assets/json/excelHeaders.json').subscribe(
      data => {
        this.columnsExcelData = data;
        this.ordersTableExcelHeaderColumns = this.columnsExcelData.calendar;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }
  exportExcel() {
    for (let js of this.excelCalData) {
      delete js.id;
      delete js.payroll_due_dt;
      delete js.pay_dt;
      delete js.valid_from_dt;
      delete js.valid_to_dt;
      delete js.cal_run_id;
      delete js.unlock;
      delete js.off_cycle;
      delete js.created_by;
      delete js.editMode;
      delete js.commPeriod;
      delete js.comment;
      delete js.updated_by;
      delete js.updated_dt;
      delete js.created_dt;
    }
    this.dataForExcel = [];
    let reportData = null;
    this.excelCalData.forEach((row: any) => {
      console.log("obj === " + Object.values(row));
      this.dataForExcel.push(Object.values(row));
    })
     reportData = {
      title: 'PayrollCalendar',
      data: this.dataForExcel,
      headers: Object.keys(this.ordersTableExcelHeaderColumns[0])
    }
    this.ete.exportExcel(reportData);
  }

  public insertCalendarType(calcForm: NgForm): void {
    this.showLoading = true;
    const formData = this.calendarService.createCalTypeForm(calcForm.value);
    this.calendarService.addCalendarType(formData).subscribe(
      (response: CalendarModel) => {
        this.clickButton('closeAddButton');
        this.notificationService.sendNotification(NotificationType.SUCCESS, `Calendar Type added successfully`);
        this.getCalList();
        calcForm.reset();
        this.showLoading = false;
      }, (errorResponse: HttpErrorResponse) => {
        this.showLoading = false;
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  public updateCalendarType(): void {
    const formData = this.calendarService.createCalTypeForm(this.calendarModel);
    this.subscriptions.push(
      this.calendarService.updateCalendarType(formData).subscribe(
        (response: CalendarModel) => {
          this.clickButton('closeEditModalButton');
          this.getCalList();
          this.notificationService.sendNotification(NotificationType.SUCCESS, `Updated successfully`);
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  public getCalList(): void {
    this.refreshing = true;
    this.subscriptions.push(
      this.calendarService.getCalList().subscribe(
        (response: CalendarModel[]) => {
          this.calData = response;
          this.excelCalData = JSON.parse(JSON.stringify(response));
          this.refreshing = false;

          const filterValue = this._normalizeValue('Active');
          this.filterData = this.calData.filter(comm => this._normalizeValue(comm.active_flag).startsWith(filterValue));

          if (this.isChecked == true) {
            this.calcData = this.calData;
          } else {
            this.calcData = this.filterData;
          }
        }, (errorResponse: HttpErrorResponse) => {
          this.refreshing = false;
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  public selectedCals(cal: any, values: any) {
    if (values.value.currentTarget.checked) {
      this.calendarModel.id = cal.row.id;
      cal.row.loggedInUser = this.loggedinUser;
      this.selctedCals.push(cal.row);
    } else {
      this.selctedCals.forEach((value: any, index: any) => {
        if (value.id == cal.id) this.selctedCals.splice(index, 1);
      });
    }
    console.log("this.selctedCals=" + JSON.stringify(this.selctedCals));
  }

  public updateStatusToActive() {
    //console.log(this.selctedCals);
    if (this.selctedCals.length === 0) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'No record selected');
    } else {
      this.calendarService.updateStatusToActive(this.selctedCals)
        .subscribe(response => {
          this.getCalList();
          response = response as ErrorResponseMessage;
          this.selctedCals = [];
          //this.isChecked = false;
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        })
    }
  }

  public updateStatusToInactive() {
    if (this.selctedCals.length === 0) {
      this.notificationService.sendNotification(NotificationType.ERROR, 'No record selected');
    } else {
    this.calendarService.updateStatusToInactive(this.selctedCals)
      .subscribe(response => {
        this.getCalList();
        response = response as ErrorResponseMessage;
        this.selctedCals = [];
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      })
    }
  }



  public onEdit(calModel: CalendarModel): void {
    this.calendarModel = calModel;
    this.clickButton('openEdit');
  }

  innerRowAction1(row: any) {
    if (row.value === 'View') {
      this.calendarService.selectedCalcModel.calendarType = row.row.calendarType;
      this.router.navigate(['/' + 'calendar-update']);
    }

    if (row.value === 'Update') {
      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.onEdit(row.row);
      }
      
    }
  }

  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns = this.columnsData.Calendar;
        console.log(this.ordersTableColumns);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );

    this.actions = [
      {
        name: 'Update',
        dataKey: 'far fa-edit success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-success'
      },
      {
        name: 'Delete',
        dataKey: 'far fa-trash-alt danger f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-danger'
      }
    ]

    this.actionButtons = [
      {
        name: 'Add',
        class: 'btn btn-primary btn-xs'
      },
      {
        name: 'Active',
        class: 'btn btn-success btn-xs'
      },
      {
        name: 'Inactive',
        class: 'btn btn-danger btn-xs'
      }
    ]

  }

  actionOnButton(action: any) {
    if (action === "Add") {
      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.clickButton(action);
      }
    } else if (action === "Active") {
      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.updateStatusToActive();
      }
     
    } else if (action === "Inactive") {
      if (this.isAccessDisabled === true) {
        this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
      } else {
        this.updateStatusToInactive();
      }
     
    }
  }

  public getInactiveCalList(): void {
    this.calcData = this.calData;
  }
  public getActiveCalList(): void {
    this.calcData = this.filterData;
  }

  changed(values: any) {
    this.isChecked = values.value.currentTarget.checked;

    if (this.isChecked == true) {
      this.getInactiveCalList();
    } else {
      this.getActiveCalList();
    }
  }

  public clickToCloseButton(buttonId: string, calTypeForm: NgForm): void {
    //document.getElementById(buttonId).click();
    calTypeForm.reset();
  }

  public clickToEditCloseButton(buttonId: string, calTypeForm: NgForm): void {
    document.getElementById(buttonId).click();
    this.getCalList();
  }

 

  private clickButton(buttonId: string): void {
    document.getElementById(buttonId).click();
  }

  public redirect(url: string) {
    this.router.navigate(['/' + url]);
  }



  public customSort = (event) => {
    console.log(event);
  }

  private _normalizeValue(value: string): string {
    if (value)
      return value.toLowerCase().replace(/\s/g, '');
    else
      return '';
  }

}